export default __webpack_public_path__ + "static/media/mail.2e5207ae.svg";